import { Discussion, Identifiable } from "@planzone/dto";
import { HttpClient, HttpMethods } from "@planzone/services";

function removeDiscussion(httpClient: HttpClient) {
  return (discussion: Identifiable<Discussion>) =>
    httpClient.sendHttpRequest<void>({
      endpoint: `/discussions/${discussion.uuid}/delete`,
      method: HttpMethods.DELETE,
    });
}

export { removeDiscussion };
